<template>
  <div v-if="!loading">
    <form>
      <h2 class="title font-weight-regular">
        Plán:
        <v-btn
          icon
          @click="showInfo('plan')"
        >
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </h2>

      <v-expansion-panels multiple>
        <v-expansion-panel
          v-for="(item, index1) in form.ciele"
          :key="index1"
        >
          <v-expansion-panel-header>
            <v-row>
              <v-col cols="11">
                <v-text-field
                  v-model="item.ciel"
                  solo
                  :disabled="form.closed"
                  label="Cieľ"
                  name="Cieľ"
                  append-icon="mdi-delete"
                  class="text-h5"
                  @click:append="deleteRowCiel(index1)"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card
              v-for="(input, index2) in item.ulohy"
              :key="index2"
              class="my-3"
            >
              <v-card-title>
                <v-textarea
                  v-model="input.navrh_uloh"
                  :disabled="form.closed"
                  label="Návrh úloh pre splnenie cieľa"
                  name="Návrh úloh pre splnenie cieľa"
                  auto-grow
                  rows="1"
                />
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="input.participuje"
                      :disabled="form.closed"
                      label="Participuje"
                      name="Participuje"
                      class="px-2"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="input.participujuca_organizacia"
                      :disabled="form.closed"
                      label="Participujúca organizácia"
                      name="Participujúca organizácia"
                      class="px-2"
                    />
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="input.termin_stavovenia_date_sync"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="input.termin_stavovenia"
                          label="Termín stanovenia úlohy"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="input.termin_stavovenia"
                        first-day-of-week="1"
                        @input="input.termin_stavovenia_date_sync = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="input.termin_splnenia_date_sync"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="input.termin_splnenia"
                          label="Termín splnenia úlohy"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="input.termin_splnenia"
                        first-day-of-week="1"
                        @input="input.termin_splnenia_date_sync = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="input.evaluacia"
                      :disabled="form.closed"
                      label="Evaluácia"
                      name="Evaluácia"
                      append-icon="mdi-delete"
                      :items="selects.evaluacia"
                      @click:append="deleteRowUloha(index1, index2)"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-btn
              text
              icon
              color="secondary"
              @click="addRowUloha(index1)"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-btn
        text
        icon
        color="secondary"
        @click="addRowCiel()"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-card class="my-5">
        <v-card-title>
          Vyhodnotenie plánu resocializačnej pomoci <v-btn
            icon
            @click="showInfo('vyhodnotenie_planu')"
          >
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.datum_vyhodnotenia"
                disabled
                label="Dátum vyhodnotenia"
                name="Dátum vyhodnotenia"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="form.vyhodnotenie_popis"
                :disabled="form.closed"
                label="Popis"
                name="Popis"
                auto-grow
                rows="1"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          color="secondary"
          @click="downloadItem()"
        >
          PDF export
        </v-btn>
        <v-btn
          class="ma-2"
          fixed
          right
          bottom
          dark
          rounded
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-text
            v-for="(item, index) in dialog_item.charakteristika"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="PotrebyPlan" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import FormSkeleton from "../components/FormSkeleton.vue";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
    },

    form: {
      id: null,
      datum_vyhodnotenia: "",
      vyhodnotenie_popis: "",
      ciele: [],
    },

    selects: {
      evaluacia: ["Splnená", "Čiastočne splnená", "Nezrealizovaná"],
    },

    manual: {
      plan: {
        nazov: "Plán",
        charakteristika: [
          "Pri plánovaní je možné prostredníctvom +pridať viac cieľov. Cieľom môže byť zabezpečiť bývanie, Obnoviť kontakty s rodinou, Riešenie závislosti, ...)",
          "Návrh úloh pre splnenie cieľa - Ide o čiastkové ciele ktoré zabezpečia dosiahnutie hlavného cieľa (Pri zabezpečení bývania to môže byť: vybavenie OP, požiadať obec o jednorazovú dávku pomoci v HN a pod.)",
          "Participuje - Uvádza sa osoba, ktorá pomáha v pri riešení stanovenej úlohy (v prípade že osoba pomáha v naplnení úlohy)",
          "Participujúca organizácia - Uvádza sa organizácia, ktorá pomáha v pri riešení stanovenej úlohy (v prípade že organizácia pomáha pri naplnení úlohy)",
          "Termín stanovenia úlohy - Uvádza sa termín, do kedy je potrebné úlohu splniť.",
          "Termín splnenia úlohy - Uvádza sa reálny dátum kedy bola úloha splnená.",
          "Evaluácia: Splnená – keď je úloha splnená označí sa ako Splnená. Čiastočne splnená – označí sa v prípade ak sú podniknuté kroky k splneniu úlohy avšak úloha ešte nebola úplne splnená. (napr. Podaná žiadosť o finančný príspevok, poslané doklady, chýba však napr. motivačný list pre nakladanie s finančným príspevkom). Nezrealizovaná – označí sa ak úlohu nezačal  ešte nikto riešiť."
        ],
      },

      vyhodnotenie_planu: {
        nazov: "Vyhodnotenie plánu resocializačnej pomoci",
        charakteristika: ["Vyhodnotenie je dôležité spracovať do termínu prepustenia nakoľko je vyhodnotenie súčasťou vyhodnotenia programu zaobchádzania."]
      }
    },
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    downloadItem() {
      apiService.getIapszPotrebyPlanExport(this.$route.params.id, this.form.id).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "iapsz_" + this.$route.params.id + "_export_plan" + ".pdf"
        );
        document.body.appendChild(link);
        link.click();
      }).catch(
        (error) => {
          this.snackbar_error = true;
        });
    },

    showInfo(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    getItem() {
      this.loading = true;
      apiService.getIapszPotrebyPlan(this.$route.params.id).then((response) => {
        this.form = response;
        this.loading = false;
      });
    },

    updateItem() {
      apiService.updateIapszPotrebyPlan(this.form, this.$route.params.id).then(
        (response) => {
          this.snackbar_saved = true;
          this.form = response;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    addRowCiel() {
      this.form.ciele.push({
        potreby_plan: this.form.id,
        ciel: null,
        splneny: null,
        vyznamna_zmena: null,
        ulohy: [],
      });

      this.updateItem();
    },
    deleteRowCiel(index) {
      this.form.ciele.splice(index, 1);
    },

    addRowUloha(index) {
      this.form.ciele[index].ulohy.push({
        ciel: this.form.ciele[index].id,
        poradie: null,
        navrh_uloh: null,
        participuje: null,
        participujuca_organizacia: null,
        termin_stavovenia: null,
        termin_splnenia: null,
        evaluacia: null,
      });
    },
    deleteRowUloha(index1, index2) {
      this.form.ciele[index1].ulohy.splice(index2, 1);
    },
  },
};
</script>